import {type RestTypeWithTypename} from '../rest-type-with-typename';

export function deletePaymentPatcher(data: {}): RestTypeWithTypename<{}> {
    return {
        __typename: 'DeletePaymentData',
        ...data,
    };
}
